import React, { useEffect, useState } from 'react';
import { hämtaKunder, hämtaInkopare, hämtaMoten, Kund, Inkopare, Mote } from '../api/client';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { TEMA } from '../theme';

export default function MinaKunder() {
  const [kunder, setKunder] = useState<Kund[]>([]);
  const [inkopare, setInkopare] = useState<Inkopare[]>([]);
  const [moten, setMoten] = useState<Mote[]>([]);
  const [laddar, setLaddar] = useState(true);
  const [fel, setFel] = useState<string | null>(null);
  const navigate = useNavigate();
  const { profil } = useAuth();

  useEffect(() => {
    setLaddar(true);
    setFel(null);
    Promise.all([hämtaKunder(), hämtaInkopare(), hämtaMoten()])
      .then(([k, i, m]) => {
        setKunder(k.data);
        setInkopare(i.data);
        setMoten(m.data);
        setLaddar(false);
      })
      .catch((err) => {
        console.error('Kunde inte ladda mina kunder:', err);
        setFel('Kunde inte ladda dina kunder just nu. Försök igen om en stund.');
        setLaddar(false);
      });
  }, []);

  // Mina kunder = kunder jag haft möten med
  const minaKundIds = new Set(
    moten
      .filter(m => m.säljare === profil?.namn)
      .map(m => m.kund_id)
  );

  const minaKunder = kunder
    .filter(k => k.aktiv && minaKundIds.has(k.kund_id))
    .sort((a, b) => a.namn.localeCompare(b.namn));

  if (laddar) return <p style={{ color: TEMA.inkFaint, fontFamily: "'Inter', sans-serif" }}>Laddar...</p>;
  if (fel) return <p style={{ color: '#D9695F', fontFamily: "'Inter', sans-serif" }}>{fel}</p>;

  return (
    <div>
      <button onClick={() => navigate('/idag')} style={{
        fontFamily: "'Inter', sans-serif", fontSize: '13px', color: TEMA.inkSoft, background: 'none', border: 'none',
        cursor: 'pointer', padding: 0, marginBottom: '16px'
      }}>
        ← Tillbaka
      </button>

      <h1 style={{ fontFamily: "'Fraunces', serif", fontSize: '26px', color: TEMA.ink, margin: '0 0 8px' }}>Mina kunder</h1>
      <p style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '12px', color: TEMA.inkFaint, margin: '0 0 24px' }}>
        {minaKunder.length} aktiva kunder
      </p>

      {minaKunder.map(k => {
        const kundInkopare = inkopare.filter(i => i.kund_id === k.kund_id);
        return (
          <div
            key={k.kund_id}
            onClick={() => navigate(`/kund/${k.kund_id}`)}
            style={{
              background: TEMA.bgPanel,
              border: `1px solid ${TEMA.border}`,
              borderRadius: '8px',
              padding: '16px 20px',
              marginBottom: '10px',
              cursor: 'pointer',
              transition: 'border-color 0.15s ease',
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = TEMA.inkSoft; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = TEMA.border; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <span style={{ fontFamily: "'Fraunces', serif", fontSize: '16px', color: TEMA.ink }}>{k.namn}</span>
              <span style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: '11px', letterSpacing: '0.04em', padding: '3px 10px',
                borderRadius: '2px', border: `1px solid ${TEMA.border}`, color: TEMA.inkSoft,
              }}>
                Segment {k.segment}
              </span>
              <span style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: '11px', letterSpacing: '0.04em', padding: '3px 10px',
                borderRadius: '2px',
                border: `1px solid ${k.fortnox_kund_nr ? TEMA.positive : TEMA.border}`,
                color: k.fortnox_kund_nr ? TEMA.positive : TEMA.inkSoft,
              }}>
                {k.fortnox_kund_nr ? 'Kund' : 'Prospect'}
              </span>
              <span style={{ marginLeft: 'auto', fontSize: '13px', color: TEMA.inkSoft, fontFamily: "'Inter', sans-serif" }}>
                {k.stad} · {k.matkoncept}
              </span>
            </div>
            {kundInkopare.length > 0 && (
              <p style={{ margin: 0, fontSize: '13px', color: TEMA.inkSoft, fontFamily: "'Inter', sans-serif" }}>
                {kundInkopare.map(i => `${i.namn} (${i.roll})`).join(' · ')}
              </p>
            )}
          </div>
        );
      })}

      {minaKunder.length === 0 && (
        <p style={{ color: TEMA.inkFaint, textAlign: 'center', marginTop: '48px', fontFamily: "'Inter', sans-serif" }}>
          Inga kunder besökta ännu.
        </p>
      )}
    </div>
  );
}